// Qual bloco React a Página do Site (menu) vai montar: calculadora (AVM), Trabalhe Conosco (TC)
// ou Anuncie seu imóvel com IA. Com mais de um marcador VÁLIDO na mesma página vale o que
// aparece PRIMEIRO no HTML (menor `antes`); os outros ficam como HTML cru (mostram o próprio
// fallback) — a mesma regra que WelcomePiecesMenu já aplicava entre AVM e TC.
//
// Empate (impossível na prática: dois marcadores não abrem no mesmo índice) fica com a ordem
// avm → tc → anuncie, que é exatamente a de antes (`splitTc` só ganhava com `<` estrito).
// Marcador inválido (sem token, JSON quebrado…) nem entra na disputa: o leitor devolve null.
//
// ⚠️ PURO (só importa os três leitores puros): roda no SSR, no navegador e no teste
// `node scripts/test-anuncie-placeholder.mjs`.

import { extrairAnunciePlaceholder } from './anuncie/placeholder';
import type { AnuncieSplit } from './anuncie/types';
import { extrairAvmPlaceholder } from './avm/placeholder';
import type { AvmSplit } from './avm/types';
import { extrairTcPlaceholder } from './tc/placeholder';
import type { TcSplit } from './tc/types';

export type PlaceholderEscolhido =
    | { tipo: 'avm'; split: AvmSplit }
    | { tipo: 'tc'; split: TcSplit }
    | { tipo: 'anuncie'; split: AnuncieSplit };

export function escolherPlaceholder(html: unknown): PlaceholderEscolhido | null {
    const candidatos: PlaceholderEscolhido[] = [];
    const avm = extrairAvmPlaceholder(html);
    if (avm) candidatos.push({ tipo: 'avm', split: avm });
    const tc = extrairTcPlaceholder(html);
    if (tc) candidatos.push({ tipo: 'tc', split: tc });
    const anuncie = extrairAnunciePlaceholder(html);
    if (anuncie) candidatos.push({ tipo: 'anuncie', split: anuncie });

    let escolhido: PlaceholderEscolhido | null = null;
    for (const c of candidatos) {
        // `<` estrito: no empate fica o primeiro da lista (avm → tc → anuncie)
        if (!escolhido || c.split.antes.length < escolhido.split.antes.length) escolhido = c;
    }
    return escolhido;
}
